import clsx from "clsx";
import { SectionTitle, TextBadge } from "components/atoms/Text";
import { ServiceList } from "data/serviceList";
import ServiceCard from "components/organism/Cards/ServiceCard";

const Service = () => {
    return (
        <section className="features w-full phone:py-12 tablet:mt-[64px] tablet:py-[64px] py-[88px] bg-neutral-20 relative z-20 overflow-hidden">
            <div className="max-w-[1440px] mx-auto">
                <img src="/images/datacenter/service/top-brick.svg" className="w-[120px] h-[95px] desktop:w-[116px] desktop:h-[118px] tablet:w-[93px] tablet:h-[95px] tablet:left-[21px] tablet:top-[126px] absolute left-[96px] top-[162px] phone:top-[196px] phone:-left-[30px]" alt="brick" />
                <img src="/images/datacenter/brick.svg" className="w-[153px] h-[170px] tablet:w-[107px] tablet:h-[119px] phone:w-[107px] phone:h-[118px] phone:bottom-[-8px] phone:right-[-11px] absolute tablet:bottom-[16px] tablet:right-[-5px] right-[55px] bottom-[24px]" alt="brick" />
                <section className={clsx(
                    "w-full max-w-full tablet:max-w-[632px] desktop:max-w-[584px] mx-auto text-center",
                    "px-6 md:px-0"
                )}>
                    <TextBadge>Service</TextBadge>
                    <SectionTitle classNames="tablet:max-w-[536px] mx-auto tablet:!text-heading-3 tablet:!leading-[54px] !pb-0">The Best Proxy Solution for You Need</SectionTitle>
                </section>
                <section className={clsx(
                    "grid grid-cols-1 md:grid-cols-4 phone:gap-6 tablet:gap-5 gap-[32px]",
                    "pt-[72px] tablet:pt-14 phone:pt-12 phone:pb-0 px-6 tablet:px-8 desktop:px-[120px] z-30 relative"
                )}>
                    {ServiceList.map((item) => (
                        <ServiceCard key={item.id} icons={item.icons} title={item.title} description={item.description} />
                    ))}
                </section>
            </div>
        </section>
    );
};

export default Service;